export default function isCompleteStep() {
  return window.location.hash.split("/").indexOf("complete") !== -1;
}



// WEBPACK FOOTER //
// ./src/helpers/isCompleteStep.js